import { FunctionComponent } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { connect, useDispatch } from "react-redux";
import { properFormat } from "../../Values/utils";
import styles from "./AnalyticsGraph.module.css";
import Chart from "react-apexcharts";
import {themeColors} from "../../Components/theme";


type props = {
  GraphType: any;
  data: any;
  Heading: string;
  stage?: any;
  title: string;
  value: string;
  role: string;
  history: any;
  contacts: any;
  filter: "MTD" | "YTD" | "PM" | "All" | "CUSTOM" | "T" | "Y";
  type:
  | "project"
  | "location"
  | "budget"
  | "stage"
  | "property_type"
  | "property_stage"
  | "other"
  | "Overdue"
  | "Pending"
  | "Completed";
  user: any;
  organizationUsers: any[];
  teamLeadUsers: any[];
  theme: any;
};
const AnalyticsGraph: FunctionComponent<props> = ({
  GraphType,
  data,
  Heading,
  stage,
  title,
  value,
  role,
  history,
  contacts,
  filter,
  type,
  user,
  organizationUsers,
  teamLeadUsers,
  theme
}) => {
  const [tableData, setTableData] = useState<any[]>([]);
  const [allContacts, setAllContacts] = useState<any[] | undefined>(undefined);

  useEffect(() => {
    let contact: any[] = [];
    Object.keys(contacts.data).forEach((key) => {
      contact = [...contact, ...contacts.data[key]];
    });
    setAllContacts(contact);
  }, [contacts.data]);
  useEffect(() => {
    if (
      (Heading === "FeedBack" ||
        Heading === "Interested Budget Summary" ||
        Heading === "Interested Location Summary" ||
        Heading === "Interested Project Summary" ||
        Heading === "Over Due Tasks" ||
        Heading === "Pending Tasks") &&
      stage
    ) {
      const tempList: any[] = [];
      Object.keys(stage).forEach((key) => {
        tempList.push({
          val: key === "" ? "Undefined" : key,
          count: stage[key],
        });
      });
      if (Heading !== "Over Due Tasks" && Heading !== "Pending Tasks") {
        let gt = 0;
        tempList.forEach((item) => {
          gt += item.count;
        });
        tempList.unshift({ val: "Grand Total", count: gt });
      }

      setTableData(tempList);
    }
    if (Heading === "Completed Tasks") {
      const tempList: any[] = [];
      Object.keys(stage).forEach((key) => {
        tempList.push({
          val: key === "" ? "Undefined" : key,
          count: stage[key]["Completed"],
        });
      });
      setTableData(tempList);
    }
  }, [stage]);
  const dispatcher = useDispatch();
  const barOptions = {
    title: {
      display: false,
      fontSize: 20,
    },
    scales: {
      x: {
        grid: {
          display: false
        }
      },
      y: {
        grid: {
          display: false
        }
      }
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display:true
      },
       datalabels: {
          display: true,
          color: "black",
          formatter: Math.round,
          anchor: "end",
          offset: -20,
          align: "start"
        },
    }
  };

  const areaChartOptions:any = {
    options: {
      chart: {
        id: "apexchart-example",
        background: theme ? 'rgba(0, 0, 0, 0)' : 'rgba(26, 43, 60, 1)',
        toolbar:{
          show: true,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            // reset: true | '<img src="/static/icons/reset.png" width="20">',
            customIcons: []
          },
          export: {
            csv: {
              filename: undefined,
              columnDelimiter: ',',
              headerCategory: 'category',
              headerValue: 'value',
              // dateFormatter(timestamp) {
              //   return new Date(timestamp).toDateString()
              // }
            },
            svg: {
              filename: undefined,
            },
            png: {
              filename: undefined,
            }
          },
          autoSelected: 'zoom' 
        }
      },
      xaxis: {
        categories: data.labels,
        tooltip: {
          enabled: false,
        },
        labels: {
          show: true,
          style: {
            colors: theme ? "#000":"#fff",
        },
        },
      },
      yaxis: {
        // title: {
        //   text: '$ (thousands)'
        // },
        labels: {
          show: true,
          style: {
            colors: theme ? "#000":"#fff",
        },
        },
      },
      colors: Heading === "Completed Tasks" ? ["#87CBAC"]:Heading === "Over Due Tasks"? ["#ff6961"]:Heading === "Pending Tasks"? ["#fffe7a"]:Heading === "Interested Lead Trends"?["#87CBAC"]:Heading==="Interested Location Summary"?["#87CBAC"]:["#71CACC"],
    },
    series: [
      {
        name:  Heading === "Completed Tasks" ? "Completed Taks":Heading === "Over Due Tasks"? "Overdue Tasks":Heading === "Pending Tasks"? "Pending Tasks":Heading === "Call Log Trends"?"Calls":"Interested",
        data: data.datasets[0].data,
      },
    ],
  };

  const donutChartOptions = {
    series: data.datasets[0].data,
    options: {
      chart: {
        toolbar: {
          show: false
        }
      },
      dataLabels: {
        enabled: false,
      },
      labels: data.labels,
      colors: [
        "#71CACC",
        "#87CBAC",
        "#3B6064",
        "#F88377",
        "#279EA0",
        "#aaf0d1",
        "#ff6961",
        "#93FCF8",
        "#00C9D2",
      ],
      plotOptions: {
        pie: {
          customScale: 0.9,
          donut: {
            size: "75%",
          },
          offsetY: 20,
        },
        stroke: {
          colors: undefined,
        },
      },
      // plotOptions: {
      //   pie: {
      //     donut: {
      //       labels: {
      //         show: true,
      //       },
      //       // total: {
      //       //   show: true,
      //       //   showAlways: true,
      //       //   fontSize: "22px",
      //       //   fontFamily: "Helvetica, Arial, sans-serif",
      //       //   fontWeight: 600,
      //       //   label: 156,
      //       //   color: "#0065bd",
      //       //   formatter: function (w: any) {
      //       //     return "Aman";
      //       //   },
      //       // },
      //     },
      //   },
      // },
    },
  };

  const barChartOptions:any = {
    series: [
      {
        name: "Total",
        data: data.datasets[0].data,
      },
    ],
    options: {
      chart: {
        background: theme ? 'rgba(0, 0, 0, 0)' : 'rgba(26, 43, 60, 1)',
        toolbar: {
          show: true,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            // reset: true | '<img src="/static/icons/reset.png" width="20">',
            customIcons: []
          },
          export: {
            csv: {
              filename: undefined,
              columnDelimiter: ',',
              headerCategory: 'category',
              headerValue: 'value',
              // dateFormatter(timestamp) {
              //   return new Date(timestamp).toDateString()
              // }
            },
            svg: {
              filename: undefined,
            },
            png: {
              filename: undefined,
            }
          },
          autoSelected: 'zoom' 
        }
      },
      // chart: {
      //   type: 'bar',
      //   height: 350
      // },
      colors: [
        "#71CACC",
        "#87CBAC",
        "#3B6064",
        "#F88377",
        "#279EA0",
        "#aaf0d1",
        "#ff6961",
        "#93FCF8",
        "#00C9D2",
      ],
      plotOptions: {
        bar: {
          distributed: true,
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: -20,
        style: {
          fontSize: '12px',
          // fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 'bold',
          colors: theme ? ["#000"]:["#fff"],
      },
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: data.labels,
        labels: {
          show: true,
          trim:true,
          style: {
            colors: theme ? "#000":"#fff",
        },
        },
      },
      yaxis: {
        // title: {
        //   text: '$ (thousands)'
        // },
        labels: {
          show: true,
          style: {
            colors: theme ? "#000":"#fff",
        },
        },
      },
      legend: {
        show: false,
      },
      fill: {
        opacity: 1,
      },
      // tooltip: {
      //   y: {
      //     formatter: function (val) {
      //       return "$ " + val + " thousands"
      //     }
      //   }
      // }
    },
  };

  const pieChartOptions:any = {
    series: data.datasets[0].data,
    options: {
      chart: {
        background: theme ? 'rgba(0, 0, 0, 0)' : 'rgba(26, 43, 60, 1)',
        toolbar: {
          show: true,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            // reset: true | '<img src="/static/icons/reset.png" width="20">',
            customIcons: []
          },
          export: {
            csv: {
              filename: undefined,
              columnDelimiter: ',',
              headerCategory: 'category',
              headerValue: 'value',
              // dateFormatter(timestamp) {
              //   return new Date(timestamp).toDateString()
              // }
            },
            svg: {
              filename: undefined,
            },
            png: {
              filename: undefined,
            }
          },
          autoSelected: 'zoom' 
        }
      },
      labels: data.labels,
      dataLabels: {
        enabled: true,
        formatter: function (val:any) {
          return val.toFixed(0) + "%"
        },
      },
      colors: [
        "#71CACC",
        "#87CBAC",
        "#3B6064",
        "#F88377",
        "#279EA0",
        "#aaf0d1",
        "#ff6961",
        "#93FCF8",
        "#00C9D2",
      ],
      legend: {
        show: true,
        labels: {
          colors: theme ? "#000":"#fff",
      }
      }
    },
  };

  const customRadialBarChartOptions = {
    series: data.datasets[0].data,
    options: {
      chart: {
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        radialBar: {
          offsetY: 0,
          startAngle: 0,
          endAngle: 270,
          hollow: {
            margin: 5,
            size: "50%",
            background: "transparent",
            image: undefined,
          },
          dataLabels: {
            name: {
              show: true,
            },
            value: {
              show: true,
            },
            // total: {
            //   show: true,
            //   label: "Total",
            //   formatter: function (w: any) {
            //     return total;
            //   },
            // },
            formatter: function (val: any, opts: any) {
              return opts.w.config.series[opts.seriesIndex];
            },
          },
        },
      },
      colors: ["#87CBAC", "#aaf0d1", "#addfad"],
      labels: data.labels,
      legend: {
        show: true,
      },
    },
  };

  const chartContainer = {backgroundColor:theme ? themeColors.cardBackgroundColor:themeColors.cardBackgroundColorDark,color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark}
  return (
    <div className="d-flex flex-column gap-5 mb-5">
    <div 
    // className={styles.graphContainer}
    className="d-flex flex-row gap-4"
    >
          <div
            className="card p-4 shadow rounded"
              style={
                Heading === "Completed vs. Overdue" ||
                  Heading === "Call Log Trends Summary" ||
                  Heading === "Call Log Trends" ||
                  Heading === "Interested Lead Trends" ||
                  Heading === "Interested Lead Trends Summary"
                  ? {  minWidth: "100%",  width: "100%",
                  maxWidth: "100%",...chartContainer}
                  : {    minWidth: "60%",
                  maxWidth: "60%",
                  width:"60%",                  
                  minHeight: "400px",
                  maxHeight: "400px",
                  ...chartContainer}
              }
          >
      <h6 className={styles.heading}>{Heading === "Interested Budget Summary" ? "Interested Budget":Heading === "Interested Project Summary" ? "Interested Project" :Heading === "Interested Location Summary" ?  "Interested Location": Heading === "FeedBack" ? "Feedback" : Heading==="Pending Tasks"?"Upcoming Tasks":Heading}</h6>
      <div
      // className={styles.graphBox}
      style={{minWidth: "100%",
      maxWidth: "100%",
      width: "100%",
      overflowX: "auto",
      color: "black"
    }}
    >
      {
        Heading === "FeedBack" ? 
        <Chart
          options={pieChartOptions.options}
          series={pieChartOptions.series}
          type="pie"
          width={"100%"}
          height={250}
        />:  Heading === "Interested Budget Summary" ? 
        <Chart
          options={barChartOptions.options}
          series={barChartOptions.series}
          type="bar"
          width={barChartOptions.series[0].data.length * 100}
          minWidth={"100%"}
          height={280}
        />:Heading === "Interested Project Summary" ? 
        <Chart
          options={areaChartOptions.options}
          series={areaChartOptions.series}
          type="area"
          width={areaChartOptions.series[0].data.length * 100}
          height={280}
        />:Heading === "Interested Location Summary" ? 
        <Chart
          options={areaChartOptions.options}
          series={areaChartOptions.series}
          type="area"
          width={areaChartOptions.series[0].data.length * 100}
          height={280}
        />:
        Heading === "Completed Tasks" ? 
        <Chart
          options={areaChartOptions.options}
          series={areaChartOptions.series}
          type="area"
          width={areaChartOptions.series[0].data.length * 100}
          height={280}
        />:Heading === "Over Due Tasks" ? 
        <Chart
          options={areaChartOptions.options}
          series={areaChartOptions.series}
          type="area"
          width={areaChartOptions.series[0].data.length * 100}
          height={280}
        />:Heading === "Pending Tasks" ? 
        <Chart
          options={areaChartOptions.options}
          series={areaChartOptions.series}
          type="area"
          width={areaChartOptions.series[0].data.length * 100}
          height={280}
        />:
        <Chart
          options={areaChartOptions.options}
          series={areaChartOptions.series}
          type="area"
          width={areaChartOptions.series[0].data.length * 100}
          height={280}
        />
      }
        </div>
          </div>
    {/* <div
      className={styles.line}
      style={
        Heading === "Completed vs. Overdue" ||
          Heading === "Call Log Trends Summary" ||
          Heading === "Call Log Trends" ||
          Heading === "Interested Lead Trends" ||
          Heading === "Interested Lead Trends Summary"
          ? { height: "0%" }
          : {}
      }
    >
    </div> */}
    {(Heading === "FeedBack" ||
      Heading === "Interested Budget Summary" ||
      Heading === "Interested Project Summary" ||
      Heading === "Interested Location Summary") && (
        <div 
        // className={styles.detailsBox}
        className="card p-4 shadow rounded w-100"
        style={{ minHeight: "400px", maxHeight: "400px",...chartContainer }}
        >
          {/* <p className={styles.graphHeading}>{Heading}</p> */}
          {Heading === "FeedBack" ? <h6 className={styles.heading2}>{Heading} Summary</h6>:<h6 className={styles.heading2}>{Heading}</h6>}
          <div style={{overflowY:"auto"}}>
          <div className={styles.typeBox}>
            <p 
            // className={styles.text}
            >{properFormat(title)}</p>
            <p 
            // className={styles.text}
            >{properFormat(value)}</p>
          </div>
          <div className={styles.graphLine}></div>
          {tableData.map((item, index) => (
            <>
              <div className={styles.typeBox}>
                <p 
                // className={styles.text}
                >{properFormat(item.val)}</p>
                <p
                  // className={styles.text}
                >
                  {item.count}
                </p>
              </div>
              <div className={styles.graphLine}></div>
            </>
          ))}
          </div>
        </div>
      )}

    {(Heading === "Over Due Tasks" ||
      Heading === "Completed Tasks" ||
      Heading === "Pending Tasks") && (
        <div 
        // className={styles.detailsBox}
        className="card p-4 shadow rounded w-100"
        style={{ minHeight: "400px", maxHeight: "400px",...chartContainer }}
        >
          {/* <p className={styles.graphHeading}>{Heading}</p> */}
          <h6 className={styles.heading2}>{Heading==="Pending Tasks"?"Upcoming Tasks":Heading} Summary</h6>
          <div style={{overflowY:"auto"}}>
          <div className={styles.typeBox}>
            <p 
            // className={styles.text}
            >Date</p>
            <p 
            // className={styles.text}
             style={{ marginLeft: "50px" }}>
              Meeting
            </p>
            <p 
            // className={styles.text}
            >Call Back</p>
            <p 
            // className={styles.text}
            >Site Visit</p>
          </div>
          <div className={styles.graphLine}></div>
          {tableData.map((item, index) => (
            <>
              <div className={styles.typeBox}>
                <p 
                // className={styles.text}
                >{item.val}</p>
                <p
                  // className={styles.text}
                >
                  {item.count.Meeting}
                </p>
                <p
                  // className={styles.text}
                >
                  {item.count["Call Back"]}
                </p>
                <p
                  // className={styles.text}
                >
                  {item.count["Site Visit"]}
                </p>
              </div>
              <div className={styles.graphLine}></div>
            </>
          ))}
          </div>
        </div>
      )}
  </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    role: state.user.role,
    contacts: state.contacts,
    user: state.user.data,
    organizationUsers: state.organizationUsers.data,

    teamLeadUsers: state.teamLeadUsers.data,
    theme: state.theme.isLightMode
  };
};

export default connect(mapStateToProps)(AnalyticsGraph);
